export default class MobileMenu {
    constructor() {
        this.selectors = {
            'item': '.js-mobile-menu-item',
            'sub-level': '.js-mobile-menu-sub-level',
            'back': '.js-mobile-menu-back',
            'scroll': '.js-mobile-menu-scroll',
            'mover': '.js-mobile-menu-mover',
        };

        this.mobileMenu = document.getElementById('mobile-menu');

        this.menuScrollPart = document.querySelector(this.selectors['scroll']);

        this.subLevels = [{el: null}];

        this.mover = document.querySelector(this.selectors['mover']);

        // purchase process has different header
        if(this.mobileMenu) {
            this.mobileMenu.addEventListener('click', this.handleMobileMenuClick.bind(this));
        }
    }

    handleMobileMenuClick(e) {
        const subMenuItem = e.target.closest(this.selectors['item']);
        if (subMenuItem && subMenuItem.querySelector(this.selectors['sub-level'])) {
            const currentSubMenu = this.subLevels[this.subLevels.length - 1].el;
            if (currentSubMenu == null || currentSubMenu.contains(subMenuItem)) {
                e.stopPropagation();
                this.openSubMenu(subMenuItem);
            }
        }
        const subMenuItemBack = e.target.closest(this.selectors['back']);
        if (subMenuItemBack) {
            e.stopPropagation();
            this.closeSubMenu();
        }
    }

    openSubMenu(menuItem) {
        this.subLevels.push({
            el: menuItem.querySelector(this.selectors['sub-level'])
        });
        this.subLevels[this.subLevels.length - 1].el.classList.add('active');
        this.subLevels[this.subLevels.length - 1].el.style = 'overflow-x: hidden; overflow-y: auto;';
        if(this.subLevels[this.subLevels.length - 2] && this.subLevels[this.subLevels.length - 2].el) {
            this.subLevels[this.subLevels.length - 2].el.style = '';
        }

        this.mover.style = `transform: translateX(${-100 * (this.subLevels.length - 1)}%)`;
        setTimeout(() => {
            this.menuScrollPart.style = 'overflow: visible;';

        }, 250);
    }

    closeSubMenu() {
        let current = this.subLevels[this.subLevels.length - 1];
        setTimeout(() => {
            current.el.classList.remove('active');
            current.el.style = '';
            if(this.subLevels[this.subLevels.length - 1].el) {
                this.subLevels[this.subLevels.length - 1].el.style = 'overflow-x: hidden; overflow-y: auto;';
            }
        }, 250);
        this.subLevels.pop();
        this.mover.style = `transform: translateX(${-100 * (this.subLevels.length - 1)}%)`;
        if(this.subLevels.length - 1 === 0) {
            this.menuScrollPart.style = '';
        }
    }
}